import type { Priority } from '../types'

const STYLES: Record<Priority, string> = {
  LOW: 'bg-slate-100 text-slate-600',
  NORMAL: 'bg-sky-100 text-sky-800',
  HIGH: 'bg-red-100 text-red-800',
}

const LABELS: Record<Priority, string> = {
  LOW: 'Niski',
  NORMAL: 'Normalny',
  HIGH: 'Wysoki',
}

export function PriorityBadge({ priority }: { priority: Priority }) {
  return (
    <span className={`rounded px-1.5 py-0.5 text-[10px] font-medium ${STYLES[priority]}`}>
      {LABELS[priority]}
    </span>
  )
}
